export function focusOnDefault() {
  document.getElementsByClassName('enhancement-button')[0].focus();
}

export function appendDocumentTitle(title) {
  document.title = `${title} | ${document.title}`;
}
